export const timeValues = [
  { id: 5, name: "5" },
  { id: 10, name: "10" },
  { id: 15, name: "15" },
  { id: 30, name: "30" }
];
